import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoadingStateService } from '@shared/services/loading-state.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { delay } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'miq-loading-indicator',
  template: `
    <div [className]="className">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  `,
  styleUrls: ['./loading-indicator.component.scss'],
  standalone: false,
})
export class LoadingIndicatorComponent implements OnInit, OnDestroy {
  className: string;

  constructor(private loadingStateService: LoadingStateService) {}

  ngOnInit() {
    const onModeChanged = (mode: string) => (this.className = `query-bar ${mode}`);
    this.loadingStateService.mode$.pipe(untilDestroyed(this), delay(0)).subscribe(onModeChanged);
  }

  ngOnDestroy(): void {
    // required by untilDestroyed
  }
}
